import { ComponentProps, ComponentType, createElement } from 'react';
import { ChangeableValue, WithValue } from './withValue';

export interface Transformer<Model = string, Control = string> {
  /* from input to form model */
  toControl(value?: Model): Control | undefined;
  /** from form model to input */
  fromControl(value?: Control): Model | undefined;
}

export const withTransformer =
  <
    C extends ComponentType<any>,
    P extends object & WithValue<ControlVal> & ChangeableValue<ControlVal, E>,
    ModelVal,
    ControlVal,
    E extends HTMLElement = HTMLInputElement,
  >(
    Component: C,
    transformer: Transformer<ModelVal, ControlVal>,
  ) =>
  ({ value, onChange, ...props }: Omit<ComponentProps<C>, 'onChange' | 'value'> & ChangeableValue<ModelVal, E> & WithValue<ModelVal>) =>
    createElement(Component, {
      ...(props as P),
      value: transformer.toControl(value),
      onChange: (cv, e) => onChange(transformer.fromControl(cv), e),
    });
